import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store';
import { LongTermHousingRentals } from './components';
import { LoadScript } from '@react-google-maps/api';
import './index.css';

const rootElement = document.getElementById('root');
const elementMap = {
  'fz-long-term-rentals': LongTermHousingRentals,
};

const renderApp = (Component, element) => {
  const root = ReactDOM.createRoot(element);
  root.render(
    <Provider store={store}>
      {window.google ? (
        <Component />
      ) : (
        <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_API}
          libraries={['places']}
        >
          <Component />
        </LoadScript>
      )}
    </Provider>
  );
};

if (rootElement) {
  renderApp(App, rootElement);
}

Object.keys(elementMap).forEach((key) => {
  const element = document.getElementById(key);
  if (element) {
    renderApp(elementMap[key], element);
  }
});
